import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Fusion de classes Tailwind, instruite de la charte BUL.
 *
 * Sans cette configuration, `tailwind-merge` prendrait `text-display` (une
 * taille) et `text-fg` (une couleur) pour deux valeurs du même réglage et en
 * jetterait une : le titre perdrait sa taille ou sa couleur, sans erreur.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'hero',
        'display',
        'title1',
        'title2',
        'title3',
        'body',
        'subtle',
        'caption',
        'micro',
        'button',
        'price-sm',
        'price-md',
        'price-lg',
      ],
      color: [
        'transparent',
        'current',
        'white',
        'black',
        'bg',
        'canvas',
        'surface',
        'raised',
        'sunken',
        'fill',
        'fill-hover',
        'field',
        'backdrop',
        'scrim-light',
        'scrim-dark',
        'fg',
        'fg-strong',
        'fg-muted',
        'fg-faint',
        'fg-on-dark',
        'fg-on-primary',
        'line',
        'line-soft',
        'primary',
        'primary-hover',
        'primary-pressed',
        'primary-soft',
        'primary-faint',
        'primary-text',
        'brand-ink',
        'chart-strong',
        'chart-accent',
        'chart-mid',
        'chart-muted',
        'chart-wash',
        'accent',
        'accent-text',
        'accent-soft',
        'verified',
        'verified-ring',
        'verified-text',
        'verified-soft',
        'success',
        'success-soft',
        'success-pressed',
        'danger',
        'danger-soft',
        'danger-pressed',
        'attention',
        'attention-ring',
        'attention-soft',
        'reaction-love',
        'reaction-meh',
        'reaction-dislike',
        'media-bg',
        'media-fg',
        'photo-stage',
        'stage',
        'stage-fg',
        'stage-muted',
        'stage-line',
        'stage-fill',
      ],
      radius: ['xs', 'sm', 'md', 'lg', 'xl', 'pill'],
      shadow: ['floating', 'sheet', 'popover'],
      'font-weight': ['normal', 'medium'],
      ease: ['pop', 'lift', 'settle'],
    },
  },
});

export function cn(...inputs: Array<ClassValue>): string {
  return twMerge(clsx(inputs));
}
